import React from 'react';
import '@splidejs/react-splide/css/core';
// import { Splide, SplideSlide } from '@splidejs/react-splide';

import { FlowLayout } from 'components/FlowLayout';
import { bank, buy, sale } from 'icons/default';
import { FlowHeading } from 'components/FlowHeading';
import { FlowActions } from 'components/FlowActions';
import { ButtonType } from 'components/Button';
import { FlowCardLink } from 'components/FlowCard';
import { Icon } from 'components/tokens/Icon';
// import { Card } from 'components/Card';
// import { ImagePosition } from 'components/Card/Card';
import { Colors } from 'enums/Colors';
import { CarPrice } from 'icons/symbol';

import styles from './Dashboard.module.scss';

interface Badges {
  buyer?: string;
  seller?: string;
  loan?: string;
  leasing?: string;
}

interface Props {
  firstName: string;
  badges?: Badges;
  activeLeasing?: boolean;
  activeLoan?: boolean;
}

export const Dashboard: React.FC<Props> = ({ firstName, badges, activeLeasing, activeLoan }) => (
  <FlowLayout size="default">
    <FlowHeading title={`Hej ${firstName}!`} />
    <FlowCardLink
      title={`${activeLoan ? 'Mitt billån' : 'Ansök om billån'}`}
      href="/app/loan"
      image={<Icon icon={bank} size={46} />}
      badgeLabel={badges?.loan}
      badgeColor={Colors.Redish}
    />

    <FlowCardLink
      title={`${activeLeasing ? 'Min företagsleasing' : 'Ansök om företagsleasing'}`}
      href={`${activeLeasing ? '/app/leasing' : '/foretag/foretagsleasing'}`}
      image={<Icon icon={CarPrice} size={46} />}
      badgeLabel={badges?.leasing}
      badgeColor={Colors.Redish}
    />

    <FlowCardLink
      title="Mina köp"
      href="/app/buy"
      image={<Icon icon={buy} size={46} />}
      badgeLabel={badges?.buyer}
      badgeColor={Colors.Redish}
    />
    <FlowCardLink
      title="Mina försäljningar"
      href="/app/sell"
      image={<Icon icon={sale} size={46} />}
      badgeLabel={badges?.seller}
      badgeColor={Colors.Redish}
    />

    <div className={styles.actions}>
      <FlowActions actionName="Inställningar" type={ButtonType.Button} actionHref="/app/settings" />
    </div>
  </FlowLayout>
);
